import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './Navbar.css';

const Navbar = () => {
  const navItems = ['About', 'Skills', 'Experience', 'Projects', 'Contact', 'Play Game'];

  const scrollToSection = (item) => {
    let id = item.toLowerCase();
    if (item === 'Play Game') id = 'game';

    const element = document.getElementById(id);
    if (element) {
      // Use standard scrollIntoView which works better with scroll-snap
      // CSS scroll-margin-top handles the offset for #game
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.location.href = 'https://www.aniketshetty.me';
  };

  return (
    <motion.nav
      className="navbar"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <div className="navbar-container">
        <motion.div
          className="logo"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          onClick={scrollToTop}
          style={{ cursor: 'pointer' }}
        >
          AS
        </motion.div>

        <div className="nav-links-wrapper">
          <ul className="nav-links">
            {navItems.map((item, index) => (
              <motion.li
                key={item}
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 + 0.3 }}
              >
                <button
                  onClick={() => scrollToSection(item)}
                  className={item === 'Play Game' ? 'nav-btn-highlight' : ''}
                >
                  {item}
                </button>
              </motion.li>
            ))}
          </ul>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;
